import React from 'react'
import { useTranslation } from 'i18n'

const returnGoogleDirectionsLink = location => {
  let locationAddressStr = `${location.streetAddress}  ${location.city}, ${location.state} ${location.zipCode}`
  let addressStr = encodeURIComponent(locationAddressStr)
  return `https://www.google.com/maps/search/?api=1&query=${addressStr}`
}

const LocationListItem = ({
  location,
  isInSidebar,
  isSelected = false,
  onLocationClicked = function () {},
  changeSelectedLocation = function () {},
  onLocationHover,
}) => {
  const { t } = useTranslation('locator')
  const trackUserClick = () => {
    onLocationClicked(location)
  }
  const sidebarSelection = () => {
    if (isInSidebar === true) {
      changeSelectedLocation(location)
    }
  }
  const handleLocationHover = () => {
    if (isInSidebar === true) {
      onLocationHover(location)
    }
  }
  return (
    <div
      onClick={sidebarSelection}
      onMouseEnter={handleLocationHover}
      className={
        `locator--location-item ` + (isSelected ? 'is--active' : 'is--inactive')
      }
      id={location.id}
    >
      <div className="locator--location-item--name">{location.name}</div>
      <div className="locator--location-item--address">
        {location.streetAddress}
      </div>
      <div className="locator--location-item--city">
        {location.city}, {location.state} {location.zipCode}
      </div>
      {isInSidebar === false && (
        <a
          onClick={trackUserClick}
          href={returnGoogleDirectionsLink(location)}
          rel="noreferrer"
          target="_blank"
          alt={t('getDirectionsAlt')}
        >
          {t('getDirections')}
        </a>
      )}
    </div>
  )
}

export default LocationListItem
